import StatusCode from "../util/StatusCode";
import { Action, Reducer, Dispatch } from 'redux';
import { PageResult } from '../models/CoreModels';
import InstanceClient from "../services/InstanceClient";
import { CorePasswordChangeRequest, CorePasswordChangeResult, CorePasswordChangeUser, PasswordChangeSearchPageRequest } from "../models/CorePasswordChangeModels";
import { RequestState } from "../models/RequestState";


enum PasswordChangeType {
    LIST_USERS = 'LIST_USERS',
};

export interface PasswordChangeState {
    users: RequestState<PageResult<CorePasswordChangeUser>>
};

interface GetUsersForPasswordChanegAction extends Action<PasswordChangeType.LIST_USERS>{
    users: RequestState<PageResult<CorePasswordChangeUser>>
};

type PasswordChangeAction = GetUsersForPasswordChanegAction;

export const GetUsersForPasswordChange = (filter: PasswordChangeSearchPageRequest = {}) => (dispatch: Dispatch<GetUsersForPasswordChanegAction>) => {
    dispatch({
        type: PasswordChangeType.LIST_USERS,
        users: { code: StatusCode.PENDING }
    })

    const url = '/api/core/passwordchange/users';
    InstanceClient.get<PageResult<CorePasswordChangeUser>>(url, filter)
        .then(res =>
            dispatch({
                type: PasswordChangeType.LIST_USERS,
                users: { code: StatusCode.COMPLETE, data: res.data, }
            })
        )
        .catch(error =>
            dispatch({
                type: PasswordChangeType.LIST_USERS,
                users: { code: StatusCode.ERROR, error }
            })
        );
}

export const UpdateUserPasswords = (request: CorePasswordChangeRequest) => {
    const url = '/api/core/passwordchange/users';
    return InstanceClient.patch<CorePasswordChangeResult[], CorePasswordChangeRequest>(url, undefined, request);
}

const initialState: PasswordChangeState = {
    users: { code: StatusCode.NONE }
}

export const reducer: Reducer<PasswordChangeState, PasswordChangeAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case PasswordChangeType.LIST_USERS:
            return {
                ...state,
                users: action.users
            };
        default:
            return state;
    }
};